<template>
  <div class="MessageCode">
    <valid-van-field
      class="term"
      v-model="col"
      :label="label"
      center
      :placeholder="placeholder"
      :rules="reg"
      maxlength="6"
      type="number"
    >
      <button
        type="button"
        slot="button"
        id="buttonStyle"
        :disabled="disabled"
        @click="sendPicCode"
      >
        {{ messageButton }}
      </button>
    </valid-van-field>
    <CodePopup
      title="请输入验证码"
      @getInputPicVal="getInputPicVal"
      @define="sendcode"
      @sendPicCode="sendPicCode"
      @close="closeSend"
      :imgUrl="imgUrl"
      :value="isShowSend"
      :isShow="isShowSend"
    ></CodePopup>
  </div>
</template>

<script>
// @ is an alias to /src
import { Field, Toast } from 'vant';
import ValidHoc from '@/components/valid';
import CodePopup from './CodePopup.vue';

const ValidVanField = ValidHoc(Field);

export default {
  name: 'MessageCode',
  components: {
    ValidVanField,
    CodePopup
  },
  data() {
    return {
      disabled: false,
      messageButton: '获取验证码',
      time: 0,
      col: '',
      timeout: '',
      imgUrl:'',
      isShowSend: false,
      inputPicValSend: '',
      codeType: '1',
    };
  },
  props: [
    'label',
    'model',
    'placeholder',
    'reg',
    'IsInterface',
    'value',
    'params',
    'inputPicVal',
    'argementFlag' 
  ],
  watch: {
    col: {
      // eslint-disable-next-line no-unused-vars
      handler(value, oldVal) {
        if (oldVal === undefined) {
          this.col = this.value;
        }
        this.$emit('input', value);
      },
      deep: true,
      immediate: true,
    },
    value: {
      handler(newVal) {
        this.col = newVal;
        this.$emit('input', newVal);
      },
      immediate: true,
    },
  },
  methods: {
    getInputPicVal(val) {
      this.inputPicValSend = val;
    },
    closeSend() {
      this.isShowSend = false;
    },
    sendPicCode() {
      if (!this.argementFlag) { 
        Toast({
          message: '请先勾选同意相关协议',
          forbidClick: true,
        });
        return;
      }
      const reg = /^1[0-9]{10}$/;
      const phone = this.params.phone.replace(/\D/g, '').substr(0, 11);
      if (!phone) {
        Toast({
          message: '手机号不能为空',
        });
        return;
      } 
      if (!reg.test(phone)) {
        Toast({
          message: '请输入正确的手机号',
        });
        return;
      }
      this.isShowSend = true;
      this.$api.PublicPage.getVerify({
        phone,
        type: this.codeType,
      })
        .then((res) => {
          let str = '';
          if (res.success) {
            if (res.data.type === 'png') {
              str = `data:image/png;base64,${res.data.file}`;
            } else {
              str = `data:image/jpg;base64,${res.data.file}`;
            }
          }
          this.imgUrl = str;
        })
        .catch(() => { });
    },
    // 验证码的倒计时
    timer() {
      if (this.time > 0) {
        this.disabled = true;
        // eslint-disable-next-line no-plusplus
        this.time--;
        this.messageButton = `(${this.time}s)`;
        this.timeout = setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.messageButton = '获取验证码';
        this.disabled = false;
        clearTimeout(this.timeout);
      }
    },
    sendcode(obj) {
      if (!obj.value) {
        return
      }
      if(!this.inputPicValSend){
        Toast({
          message: '图形验证码不能为空',
        });
      }
      const paramsObj = JSON.parse(JSON.stringify(this.params));
      paramsObj.code = this.inputPicValSend;
      console.log(paramsObj.method);
      this.$api.PublicPage[paramsObj.method](paramsObj)
        .then((res) => {
          if (!res.success) {
            this.sendPicCode()
            if (res.returnCode === '30010') {
              this.$emit('getSendPicCode', true);
            }
            Toast({
              message: res.returnMessage,
              forbidClick: true, // 背景不可点击
            });
            this.disabled = false;
          } else {
            this.isShowSend = false;
            this.time = 60;
            this.timer();
          }
        })
        .catch((e) => {
          console.log(e);
          this.disabled = false;
        });
    },
  },
};
</script>
<style>
.bgColor {
  background: #f8f8f9;
}
.van-button--small {
  min-width: 60px;
  height: 30px;
  padding: 0 8px;
  color: #ff6538;
  font-size: 12px;
  line-height: 28px;
  background-color: #fff;
}

.buttonDe {
  margin: 0;
  color: #ccc;
  font-size: 14px;
  outline: none;
}
#buttonStyle {
  margin: 0;
  padding: 0;
  color: #ff6538;
  font-size: 14px;
  background: #fff;
  border: 1px solid transparent;
  outline: none;
  position: absolute;
  top: -2px;
  right: 0;
}
.MessageCode {
  position: relative;
}
.term::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: ' ';
  pointer-events: none;
}
</style>
